import React, { useState, useEffect } from "react";
import styles from "./SeriesComponent.module.css";
import AddSeries from "./AddSeries";
import { deleteSeries, getAllSeries } from "../../../service/series";
import { Series } from "../../../interface/series";

const SeriesComponent = () => {
  const [series, setSeries] = useState<Series[]>([]);
  const [showAddForm, setShowAddForm] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [editingSeries, setEditingSeries] = useState<Series | null>(null);

  const fetchSeries = async () => {
    try {
      setLoading(true);
      setError("");
      const data = await getAllSeries();
      setSeries(data);
    } catch (err: any) {
      setError(err.message || "Failed to fetch series");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id: string) => {
    if (window.confirm("Are you sure you want to delete this series?")) {
      try {
        await deleteSeries(id);
        fetchSeries();
      } catch (err: any) {
        setError(err.message || "Failed to delete series");
      }
    }
  };

  const handleEdit = (series: Series) => {
    setEditingSeries(series);
    setShowAddForm(true);
  };

  useEffect(() => {
    fetchSeries();
  }, []);

  return (
    <div className={styles.seriesContainer}>
      <div className={styles.headerRow}>
        <h2 className={styles.sectionTitle}>Furniture Series</h2>
        <button
          className={styles.addButton}
          onClick={() => {
            setEditingSeries(null);
            setShowAddForm(!showAddForm);
          }}
        >
          {showAddForm ? "Cancel" : "Add New Series"}
        </button>
      </div>

      {showAddForm && (
        <div className={styles.formContainer}>
          <AddSeries
            onSuccess={() => {
              fetchSeries();
              setShowAddForm(false);
            }}
            initialData={editingSeries}
          />
        </div>
      )}

      {error && <div className={styles.error}>{error}</div>}

      {loading ? (
        <div className={styles.loading}>Loading series...</div>
      ) : series.length === 0 ? (
        <div className={styles.noResults}>No series found</div>
      ) : (
        <div className={styles.tableContainer}>
          <table className={styles.seriesTable}>
            <thead>
              <tr>
                <th>ID</th>
                <th>Title</th>
                <th>Description</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {series.map((s) => (
                <tr key={s.id}>
                  <td>{s.id}</td>
                  <td>{s.title}</td>
                  <td>{s.description}</td>
                  <td className={styles.actionsCell}>
                    <button
                      className={styles.editButton}
                      onClick={() => handleEdit(s)}
                    >
                      Edit
                    </button>
                    <button
                      className={styles.deleteButton}
                      onClick={() => handleDelete(s.id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default SeriesComponent;
